module.exports = __webpack_public_path__ + "static/media/paint-bucket.6ba17aad.svg";